import React, { useEffect, useState } from "react";
import { UserRole } from "../../providers/authProvider";
import { BooleanInput, BooleanInputProps, useDataProvider, useGetIdentity, useNotify } from "react-admin";
import { getCompanyId } from "../../utils/utils";

export enum MustInformOdometerOrigin {
  Vehicle = 'vehicle',
  Driver = 'Driver',
}

export interface MustInformOdometerBooleanInputProps extends Omit<BooleanInputProps, 'defaultValue'> { origin: MustInformOdometerOrigin }

const MustInformOdometerBooleanInput: React.FC<MustInformOdometerBooleanInputProps> = ({ source, label, origin }) => {
  const { identity } = useGetIdentity();
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const [odometerDefault, setOdometerDefault] = useState<boolean | null>(null);

  useEffect(() => {
    if (identity?.role === UserRole.company) {
      dataProvider
        .getOne(`company-config`, { id: getCompanyId() })
        .then(({ data }) => setOdometerDefault(data[origin === MustInformOdometerOrigin.Vehicle ? 'vehicleOdometer' : 'driverOdometer']))
        .catch(() => {
          setOdometerDefault(false);
          notify('Erro ao buscar configurações atuais', { type: 'warning' });
        });
    } else if (identity?.role) {
      setOdometerDefault(false);
    }
  }, [identity]);

  return (
    odometerDefault !== null ?
      <BooleanInput source={source} label={label} defaultValue={odometerDefault} />
      :
      <></>
  );
}

export default MustInformOdometerBooleanInput;